import type { SupportedLanguage } from "@/services/locale";

/**
 * Maps language codes to their full language names
 */
const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  bg: "Bulgarian",
  da: "Danish",
  de: "German",
  en: "English",
  es: "Spanish",
  et: "Estonian",
  fi: "Finnish",
  fr: "French",
  it: "Italian",
  lt: "Lithuanian",
  lv: "Latvian",
  nl: "Dutch",
  no: "Norwegian",
  pl: "Polish",
  pt: "Portuguese",
  ru: "Russian",
  sv: "Swedish",
};

/**
 * Generates a language instruction for the AI system prompt
 * This ensures the AI always responds in the user's selected i18n language
 */
export function createLanguageInstruction(language: SupportedLanguage): string {
  const languageName = LANGUAGE_NAMES[language] || "English";

  return `## ⚠️ CRITICAL LANGUAGE REQUIREMENT ⚠️
YOU MUST ALWAYS RESPOND IN ${languageName.toUpperCase()}. This is the highest priority rule.

- All responses, explanations, messages, and text MUST be in ${languageName}
- The "explanation" field in function calls MUST be in ${languageName}
- Do not translate or use any other language
- Match the user's language preference exactly

This requirement overrides any other language instructions in this prompt.`;
}
